import { X } from "lucide-react";
import type { Profile } from "./types";

interface SelectedProfileCardProps {
  profile: Profile;
  onRemove: () => void;
}

export function SelectedProfileCard({
  profile,
  onRemove,
}: SelectedProfileCardProps) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-white p-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-10 w-10 rounded-full bg-default-100 flex items-center justify-center flex-shrink-0">
          {profile.avatar_url ? (
            <img
              src={profile.avatar_url}
              alt={profile.name}
              className="h-10 w-10 rounded-full object-cover"
            />
          ) : (
            <span className="text-default-600 font-medium text-sm">
              {profile.name.charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-medium text-slate-900 truncate">
            {profile.name}
          </div>
          {profile.slug && (
            <div className="text-sm text-slate-500 truncate">
              @{profile.slug}
            </div>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="text-slate-400 hover:text-slate-600 p-1 rounded-md hover:bg-slate-100"
        aria-label="Supprimer"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
